import APIService from 'services/APIService'

const api = APIService()

export const getTasks = () => api.get('/student-tasks')

export const toggleIsCompleted = (taskId: string) =>
  api.patch(`/student-tasks/${taskId}/toggle-completed`)
